export default "/images/vendor/flag-icon-css/flags/1x1/bs.svg?3fac313f5a20d93d24be75ca7930031f";